import { Component, Input, OnInit } from '@angular/core';
import { MENU_ITEMS } from '../../shared/providers/data/menu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  @Input() menu = MENU_ITEMS;

  constructor() { }

  ngOnInit() {

  }

  toggleSidebar(){
    console.log('sd')
    let body = document.body;
    body.classList.toggle("is-collapsed");
  }

}
